import React,{useState} from 'react';
import { Subscribe } from '../../services/servicesSubscribe';
import LoadScreenSmall from '../../components/loadScreenSmall/loadScreenSmall';
import {DivMain,DivBody,DivBodyMobile,Span,ButtonSubscribe} from './StyleButtonTrialVersion';
export default function ButtonTrialVersion() {
    const [smallScreen, setSmallScreen] = useState(false);

    async function generateTicket(){
        setSmallScreen(true);
        const ticketLink = await Subscribe();
        window.location.href = `${ticketLink}&redirectURL=https://social.medx.med.br/payment-success`;
        setSmallScreen(false);
    }
    function verifyScreenSize(){
        if(window.screen.width < 800 && localStorage.getItem('ticketLink')){
            return( <DivBodyMobile id='buttonTrial'>
               <div style={{cursor:'pointer'}} onClick={generateTicket} >
                    <span><strong>Versão de teste</strong><br /><nobr>Está gostando do nosso conteúdo ?</nobr><br />Clique aqui para </span>
                    <ButtonSubscribe style={{opacity:'0.6'}}>Assinar</ButtonSubscribe>
                </div>
            </DivBodyMobile>)
        }else{
            return(
                <DivMain id='buttonTrial'>{ localStorage.getItem('ticketLink')
                    ?
                        <DivBody >
                            <div style={{cursor:'pointer'}} onClick={generateTicket} >
                                <nobr><Span>  <strong>Versão de teste</strong> está gostando do nosso conteúdo ? Clique aqui para assinar</Span>
                                <ButtonSubscribe style={{opacity:'0.6'}}>Assinar</ButtonSubscribe> </nobr >
                            </div>
                        </DivBody>
                    :
                        ''
                    }
                    {
                        smallScreen ?
                            <LoadScreenSmall open={smallScreen} close={setSmallScreen} />
                        :
                            <></>
                    }
            </DivMain>)
        }
    }

    return verifyScreenSize()
}
